export const getFullTextOfArea = (area) => [
    area.siDo.trim(),
    area.siGunGu.trim(),
    area.eupMyeonDong.trim(),
].join('');
export const isSameDong = (dong1, dong2) => {
    // register 및 등록 가능한 동 자료는 constatntGroupId가 반드시 존재하므로 유니크 키 비교가 가능
    if ('constantGroupId' in dong1 && 'constantGroupId' in dong2) {
        return dong1.constantGroupId === dong2.constantGroupId;
    }
    // unregister 및 상점의 동 자료는 constatntGroupId가 존재하지 않을 수 있으므로 유니크 키 비교가 불가능
    const isSame = getFullTextOfArea(dong1) === getFullTextOfArea(dong2);
    return isSame;
};
export const isParentDong = (parentDong, childDong) => {
    // register 및 등록 가능한 동 자료는 constatntGroupId가 반드시 존재하므로 유니크 키 비교가 가능
    if ('constantGroupId' in parentDong && 'parentId' in childDong) {
        return parentDong.constantGroupId === childDong.parentId;
    }
    // unregister 및 상점의 동 자료는 constatntGroupId가 존재하지 않을 수 있으므로 유니크 키 비교가 불가능
    const formattedParentDong = getFullTextOfArea(parentDong);
    const formattedChildDong = getFullTextOfArea(childDong);
    const isParent = formattedParentDong !== formattedChildDong
        && !formattedParentDong.split(' ')[1]
        && formattedParentDong.split(' ')[0] === formattedChildDong.split(' ')[0];
    return isParent;
};
export const isChildDong = (childDong, parentDong) => isParentDong(parentDong, childDong);
export const isAreaRi = (area) => /^.+\s+.+리$/.test(area.eupMyeonDong);
